import { render, staticRenderFns } from "./RingCategoryNav.vue?vue&type=template&id=0e21211a&scoped=true&"
var script = {}
import style0 from "./RingCategoryNav.vue?vue&type=style&index=0&id=0e21211a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e21211a",
  null
  
)

export default component.exports